import * as types from '../../types'

// SET_BAR_IMAGE
// SET_DRAWER
// SET_SCRIM

export default {
    [types.MUTATE_UPDATE_VALUE]: (state, payload) => {
        state.value = payload
    },
    [types.MUTATE_UPDATE_BARIMAGE]: (state, payload) => {
        state.barImage = payload
        console.log('BarImage: ' + state.barImage)
    },
    [types.MUTATE_UPDATE_DRAWER]: (state, payload) => {
        state.drawer = true
        console.log('Drawer: ' + state.drawer)
    },
    [types.MUTATE_UPDATE_SCRIM]: (state, payload) => {
        state.barColor = payload
        console.log('Bar Color: ' + state.barColor)
    },
}
